import {TextBody} from '@tkww/orion-web-ds-text';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {HashLink} from 'react-router-hash-link';
import style from './SummaryInfoItem.scss';
import noop from '../../../utils/noop';

const SummaryInfoItem = ({
  sub = '',
  subIsEnabled = true,
  subLink = '',
  subLinkOnClick = noop,
  value = '',
  valueIsEnabled = true,
  valueLabel = '',
  valueLink = '',
  valueLinkOnClick = noop,
}) => {
  return (
    <TextBody size="md" className={style.info}>
      <HashLink
        smooth
        to={valueIsEnabled ? valueLink : '#'}
        alt=""
        className={cx(style['info-value'], {
          [style.disabled]: !valueIsEnabled,
        })}
        onClick={valueIsEnabled ? valueLinkOnClick : e => e.preventDefault()}>
        <strong>{value}</strong> {valueLabel}
      </HashLink>
      <TextBody size="sm" className={style['info-sub']}>
        <HashLink
          to={subIsEnabled ? subLink : '#'}
          onClick={subIsEnabled ? subLinkOnClick : e => e.preventDefault()}
          className={cx(style['info-sub-text'], {
            [style.disabled]: !subIsEnabled,
          })}>
          {sub}
        </HashLink>
      </TextBody>
    </TextBody>
  );
};

SummaryInfoItem.propTypes = {
  valueIsEnabled: PropTypes.bool,
  sub: PropTypes.string,
  subIsEnabled: PropTypes.bool,
  subLink: PropTypes.string,
  value: PropTypes.string,
  valueLabel: PropTypes.string,
  valueLink: PropTypes.string,
  valueLinkOnClick: PropTypes.func,
  subLinkOnClick: PropTypes.func,
};

export default SummaryInfoItem;
